import type { ModalIbanAccountStep, QuizStepProps } from "@/features/user/quiz/types.ts";
import { useTranslation } from "react-i18next";
import { Base, SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Themes } from "@/types/theme.ts";
import { RadioCard } from "@/atoms-react/radio-card/index.react.tsx";

enum ModalRadiosTransKeys {
  YesCommunicate = "perso_only",
  Nope = "perso_pro"
}
export const AccountUsageStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);
  const handleRadioBoxChange = (selectedOption: string) => {
    setQuizResponses?.((prev) => ({
      ...prev,
      account_usage: { ...prev.account_usage, trans_key: selectedOption }
    }));
  };
  const isQuizAnswered = () => {
    if (!quizResponses?.account_usage || Object.keys(quizResponses?.account_usage).length === 0) {
      return false;
    }
    if (quizResponses?.account_usage?.trans_key === null) {
      return false;
    }
    return true;
  };
  return (
    <>
      <SectionTitleSmall className="mt-2 mb-4 block">
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.account_usage.question")}
      </SectionTitleSmall>
      <div className="my-4 mt-auto w-full space-y-4">
        {[ModalRadiosTransKeys.YesCommunicate, ModalRadiosTransKeys.Nope].map((m) => (
          <RadioCard
            dataCy={`account_usage.question`}
            active={
              (quizResponses?.account_usage &&
                quizResponses?.account_usage?.trans_key === m) as boolean
            }
            key={m}
            onClick={() => handleRadioBoxChange(m)}
          >
            <Base>
              {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.account_usage.responses." + m)}
            </Base>
          </RadioCard>
        ))}
      </div>
      <div className="mt-auto mb-4 flex flex-col items-center">
        <DotsNavigation total={totalSteps} current={stepSettings.current} className="mb-4" />
        <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
          <Button
            theme={Themes.white}
            onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
          >
            {t("olkypass.general.go_back")}
          </Button>

          <Button
            disabled={!isQuizAnswered()}
            dataCy="account_usage-step-continue"
            onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
          >
            {t("olkypass.general.continue")}
          </Button>
        </div>
      </div>
    </>
  );
};
